module.exports = __webpack_public_path__ + "static/media/new_imobiliaria.810319f1.png";